<template lang="pug">
.c-progress-form__footer
  .row.flex.center-align
    .column.medium-6
      span.show-for-medium
        span.c-progress-form__status
          | {{roundedPercentage}}% complété
      .c-progress-form__bar(:style="percentage")
    .column.medium-6
      .button-group.float-right
        button.button.link(@click="goBack()") Retour
        button.c-progress-form__button.button.primary(@click="goNext()" :disabled="disabled") Continuer
</template>

<script>
export default {
  props: {
    back: {
      default: '/'
    },
    next: '',
    percent: {
      default: 0
    },
    spinnerTime: {
      default: 0
    }
  },
  computed: {
    roundedPercentage () {
      return Number.parseFloat(this.percent).toFixed()
    },
    percentage: function () {
      return `background-size: ${this.percent}% 100%`
    },
    disabled: function () {
      return this.percent !== 100
    }
  },
  methods: {
    goBack () {
      this.$router.push(this.back)
    },
    goNext () {
      this.$store.dispatch('longLoading', this.spinnerTime)
      setTimeout(() => {
        this.$router.push(this.next)
      }, this.spinnerTime)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/shared/ProgressBar.vue